import { render, staticRenderFns } from "./StallionHistoriqueSyndication.vue?vue&type=template&id=255f4afc&"
import script from "./StallionHistoriqueSyndication.vue?vue&type=script&lang=js&"
export * from "./StallionHistoriqueSyndication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports